<template>
  <div class="content container mx-auto px-4">
    <div>
      <h1 class="title text-gray-700">联系我们</h1>
      <p v-if="config.mobile">电话：{{ config.mobile }}</p>
      <p v-if="config.email">
        邮件：<a a target="_blank" :href="'mailto:' + config.email">{{
          config.email
        }}</a>
      </p>
      <p style="margin-top: 24px">
        公司地址：北京北京市朝阳区北美国际产业园c栋
      </p>
    </div>
    <div>
      <p v-if="config.address">{{ config.address }}</p>
      <p v-if="config.zipcode">{{ config.zipcode }}</p>
    </div>
    <div v-if="config.qrcodes">
      <h1 class="title text-gray-700" style="margin-top: 80px">关注我们</h1>
      <div
        class="inline-block mr-10"
        v-for="(item, i) in config.qrcodes"
        :key="i"
      >
        <div>{{ item.name }}</div>
        <br />
        <img width="220" :src="getQrcodeUrl(item.url)" />
      </div>
    </div>
  </div>
</template>

<script>
import config from "@saas/components/src/config/company.json";
import { getCdnUrl } from "@saas/components/src";
export default {
  name: "ContactPage",
  data() {
    return {
      config: Object.freeze(config.contact || {}),
    };
  },
  methods: {
    getQrcodeUrl(url) {
      if (!url) return '';
      // 处理协议相对 URL (//cdn.xxx.com/...)
      if (url.startsWith('//')) {
        return getCdnUrl('https:' + url);
      }
      return getCdnUrl(url);
    },
  },
};
</script>

<style scoped>
.container {
  margin: 20px auto;
  background: var(--card-bg);
  color: var(--text-secondary);
  width: 1140px !important;
  max-width: 1140px !important;
  padding: 0;
  min-height: calc(100vh - 300px);
  font-size: 16px;
  padding: 60px 80px;
}
.title {
  margin-bottom: 32px;
  font-size: 32px;
  font-weight: bold;
  color: var(--text-primary) !important;
}
</style>
